import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, WacPagesMethod, WacPagesReadRecordsResponse, WacPagesRecord, Dependencies } from '../types';
import { API_TYPE_QUARANTINE } from '../../../webcomponents.constants';
import { GetRowsRequest, GetSummaryResponse, UpdateSettingsRequest, UpdateSettingsResponse } from '../../../grid/types/common';
import { TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';
import { ConsoleRequest, DataProviderType, FilterKeyMapper } from '../../../utils/request';
import { Filter } from '../../../grid/gridFilters/types';

export class WebAccessControlCustomPagesGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private endpoint = 'WebAccessControlCustomPages';
  private cache: WacPagesReadRecordsResponse | null;
  public companyFilterDataProvider = API_TYPE_QUARANTINE;

  /**
   * Maps column key to different filter key as we filter with a different one.
   */
  private filterKeyMapper: FilterKeyMapper = {
    'company.name': 'company.id',
  };

  constructor(public dependencies: Dependencies) {
    super();
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    const response = await this.readRecords(request);
    return {
      numItems: response.total,
      summary: '',
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<{ rawEvents: Array<WacPagesRecord> }> {
    const response = await this.readRecords(request);
    return { rawEvents: response.data };
  }

  async setFilters(request: any): Promise<{} | undefined> {
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  private async readRecords(request: GetRowsRequest<Column, ColumnKeys>): Promise<WacPagesReadRecordsResponse> {
    let response: WacPagesReadRecordsResponse;

    if (this.cache) {
      response = this.cache;
      this.cache = null;
      return response;
    }

    const requestFilters: Array<Filter<ColumnKeys>> = [];
    for (const item of request.filters) {
      if (Object.keys(item)[0] === "updated.date" && item["updated.date"].timeRange.kind === TimeRangeKind.ALL_TO_DATE) {
        continue;
      }
      requestFilters.push(item);
    }

    request.filters = requestFilters;

    const payload = ConsoleRequest.mapGridRequestToPayload(request, Application.Main.getUser().profile.timezone, this.filterKeyMapper);
    payload.filter.push({"property": "company.id", "value": [Application.Main.getActiveCompany().id]});

     response = await ConsoleRequest.createRequest<WacPagesReadRecordsResponse>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload,
      endpoint: this.endpoint,
      method: WacPagesMethod.READ_RECORDS,
    });

    this.cache = response;

    return response;
  }

}
